import NotificationService from '@/components/notification-service';
import FrontendHttpClient from '@/utils/http-handler/frontend-http-client';
import { EMAIL_TEMPLATE_SCOPE } from '@certificate_hero/enums';
import { route } from 'nextjs-routes';
import { useCallback } from 'react';
import useSWR from 'swr';

export const useEmailTemplates = () => {
  const swr = useSWR(
    route({ pathname: '/api/v2/email_templates' }),
    async url => {
      const res = await FrontendHttpClient.get(url);
      return res.data.result;
    }
  );

  const { data: emailTemplates, mutate } = swr;

  const getDefaultTemplateByRole = useCallback(
    ({ role, divisionNumber }) => {
      if (!emailTemplates) {
        return null;
      }

      return emailTemplates.find(
        t =>
          t.role === role &&
          t.scope === EMAIL_TEMPLATE_SCOPE.GLOBAL &&
          t.divisionNumber === divisionNumber
      );
    },
    [emailTemplates]
  );

  const getDefaultTemplateByUserIdAndRole = useCallback(
    ({ role, userId }) => {
      if (!emailTemplates) {
        return null;
      }

      return emailTemplates.find(
        t =>
          t.role === role &&
          t?.userId == userId &&
          t.scope === EMAIL_TEMPLATE_SCOPE.USER
      );
    },
    [emailTemplates]
  );

  const update = useCallback(
    async ({ id, newData, userId, divisionNumber, role }) => {
      try {
        await FrontendHttpClient.put(
          route({
            pathname: '/api/v2/email_templates/[id]',
            query: { id },
          }),
          {
            values: newData,
            ...(role ? { role } : {}),
            ...(userId ? { userId, scope: EMAIL_TEMPLATE_SCOPE.USER } : {}),
            ...(divisionNumber
              ? { divisionNumber, scope: EMAIL_TEMPLATE_SCOPE.GLOBAL }
              : {}),
          }
        );
        await mutate();
      } catch (err) {
        NotificationService.error('Error updating new template');
        return;
      }
      NotificationService.success('Template updated');
    },
    [mutate]
  );

  return {
    ...swr,
    getDefaultTemplateByRole,
    getDefaultTemplateByUserIdAndRole,
    update,
  };
};
